'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("userTaskService", function ($http, $q, $notifications, $stickyBox, $fileDownload) {
  var poolingInterval = 2500;
  var watchedTasks = [];
  // map taskId, callback
  var watchedTasksTerminationCallback = {};
  var watchedTasksProgressionCallback = {};
  var pooling = false;
  var currentTasks = [];
  var popinOpened = false;
  var startPooling = function startPooling() {
    if (pooling) {
      return;
    }
    pooling = true;
    fetchTasks();
    _poolingHandler();
  };
  var _poolingHandler = function poolingHandler() {
    _.delay(function () {
      fetchTasks().then(function (tasks) {
        currentTasks = tasks;
        _.each(currentTasks, notifyTaskProgression);
        var terminatedIds = getTerminatedTaskIds(tasks, watchedTasks);
        _.each(terminatedIds, notifyTerminatedTask);
        if (watchedTasks.length > 0) {
          _poolingHandler();
        } else {
          pooling = false;
        }
      });
    }, poolingInterval);
  };
  var getTerminatedTaskIds = function getTerminatedTaskIds(tasks, watchedIds) {
    var tasksIds = _.chain(tasks).filter(function (t) {
      return t.status === "COMPLETED" || t.status === "ERROR";
    }).map("id").value();
    return _.intersection(tasksIds, watchedIds);
  };
  var _getJSonGeneration = function getJSonGeneration(taskId) {
    return $http.get("/rest/user-tasks/result/".concat(taskId, "/json"));
  };
  var notifyTaskProgression = function notifyTaskProgression(task) {
    if (task.status !== 'COMPLETED' && task.status !== 'ERROR') {
      var callback = watchedTasksProgressionCallback[task.id];
      if (callback != null) {
        callback(task);
      }
    }
  };
  var notifyTerminatedTask = function notifyTerminatedTask(taskId) {
    var task = _.find(currentTasks, {
      id: taskId
    });
    console.log('notifyTerminatedTask', task);
    var type = task.result && task.result.type;
    if (task.status === 'ERROR') {
      $notifications.error("Tâche terminée en erreur : " + task.message);
      console.log(task);
    } else {
      switch (type) {
        case "FILE_GENERATION":
          {
            $notifications.info(getFileGenerationCompletedMessage(task), {
              life: 15 * 1000
            });
            break;
          }
        case "DTO_GENERATION":
          {
            console.log('DTO_GENERATION', task);
            _getJSonGeneration(taskId).then(function (result) {
              console.log("dto_result", result);
              console.log('DTO convert=', result.data);
              watchedTasksTerminationCallback[taskId](result.data);
            });
            break;
          }
        default:
          {
            $notifications.info("Tâche terminée. Ouvrez le gestionnaire pour obtenir son résultat.");
          }
      }
    }
    watchedTasks = _.without(watchedTasks, taskId);
  };
  var getFileGenerationCompletedMessage = function getFileGenerationCompletedMessage(task) {
    var message = $("\n            <div>\n                <span>Votre export est termin\xE9</span><br/>\n                <a href=\"#\">Cliquez ici pour t\xE9l\xE9charger le fichier</a>\n            </div>\n        ");
    message.click(function () {
      $fileDownload.start("/rest/user-tasks/downloadUserTaskGeneratedFile/" + task.id);
    });
    return message;
  };
  var fetchTasks = function fetchTasks() {
    return $http.get("/rest/user-tasks/listCurrentUserTaskReports").then(function (response) {
      currentTasks = response.data;
      return currentTasks;
    });
  };
  var getDefaultAddMessage = function getDefaultAddMessage() {
    return "Export déclenché. Vous serez prévenu une fois celui-ci terminé.";
  };
  var _setProgressionCallback = function setProgressionCallback(taskId, progressionCallback) {
    watchedTasksProgressionCallback[taskId] = progressionCallback;
  };
  var _startTaskWatch = function startTaskWatch(message, taskId, terminationCallback, noNotifyWatch) {
    if (!noNotifyWatch) {
      $notifications.info(message || getDefaultAddMessage());
    }
    watchedTasks.push(taskId);
    if (terminationCallback) {
      console.log('Callback enregistré pour la task ' + taskId);
      watchedTasksTerminationCallback[taskId] = terminationCallback;
    }
    if (!pooling) {
      startPooling();
    }
  };
  var _deleteTask = function deleteTask(taskId) {
    return $http.get("/rest/user-tasks/deleteUserTaskReport/" + taskId).then(function (response) {
      if (!pooling) {
        fetchTasks();
      }
    });
  };
  return {
    loadTasksIfRequired: function loadTasksIfRequired() {
      if (!pooling) {
        return fetchTasks();
      }
      return $q.resolve(currentTasks);
    },
    getCurrentTasks: function getCurrentTasks() {
      return currentTasks;
    },
    openTaskList: function openTaskList() {
      if (popinOpened) {
        return;
      }
      popinOpened = true;
      $stickyBox.open({
        title: "Tâches",
        template: "<user-task-list-popin></user-task-list-popin>",
        options: {
          width: 1000
        }
      }).then(function () {
        popinOpened = false;
      });
    },
    startReportDownload: function startReportDownload(taskId) {
      $fileDownload.start("/rest/user-tasks/downloadUserTaskGeneratedFile/" + taskId);
    },
    deleteTask: function deleteTask(taskId) {
      return _deleteTask(taskId);
    },
    deleteAllTasks: function deleteAllTasks(taskId) {
      return $http.get("/rest/user-tasks/deleteAllFinishedUserTasks").then(function (response) {
        if (!pooling) {
          fetchTasks();
        }
      });
    },
    killTask: function killTask(taskId) {
      return $http.put("/rest/user-tasks/killUserTask/" + taskId).then(function (response) {
        if (!pooling) {
          fetchTasks();
        }
      });
    },
    /**
     *
     * @param url resource @post qui fourni la réponse
     * * @param params les paramètre pour la ressource
     * @param callback en parametre le dto/list de dtos
     */
    runTask: function runTask(url, params, callback) {
      $http.post(url, params).then(function (response) {
        var taskId = response.data.taskId;
        _startTaskWatch("Traitement démarré", taskId, function (dto) {
          try {
            callback(dto);
          } catch (e) {
            console.log('expection au traitement du callback de la task ' + taskId, e);
            throw e;
          } finally {
            _deleteTask(taskId);
          }
        }, true);
      });
    },
    /**
     * methode permettant de démarrer la surveillance de la progression / completion de la tache
     * @param taskId
     * @param message
     */
    startTaskWatch: function startTaskWatch(taskId, terminationCallback, message) {
      _startTaskWatch(message, taskId, terminationCallback);
    },
    setProgressionCallback: function setProgressionCallback(taskId, progressionCallback) {
      _setProgressionCallback(taskId, progressionCallback);
    },
    getTextGeneration: function getTextGeneration(taskId) {
      return $http.get("/rest/user-tasks/result/".concat(taskId, "/text"));
    },
    getJSonGeneration: function getJSonGeneration(taskId) {
      return _getJSonGeneration(taskId);
    },
    reactivePooling: function reactivePooling() {
      if (!pooling) {
        fetchTasks().then(function () {
          _.each(currentTasks, function (t) {
            if (t.status === 'PENDING' || t.status === 'STARTED' || t.status === 'IN_PROGRESS') {
              _startTaskWatch(t.id, undefined, undefined, true);
            }
          });
        });
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/user-task/userTaskService.js
// module id = 2884
// module chunks = 13